module.exports = __webpack_public_path__ + "static/media/Kids Cartoon-100.5ecf1d13.webp";